import React, { useEffect, useMemo, useState } from "react";
import {Col,Form,Row} from "react-bootstrap";
import {  createOption } from "./createableSelect";
import "rsuite/dist/rsuite.min.css";
import { useDispatch } from "react-redux";
import CustomSelect from "components/CustomSelect";
import { Box, Button, Tooltip } from "@chakra-ui/react";
import { FaTrash } from "react-icons/fa6";
import { currencyFormate } from "jsFunctions/helperFunctions";
import { getOptionDataOnEdit } from "jsFunctions/calculateGst";
import PaymentModePdf from "./PaymentMode/paymentModePdf";
import { createAmountID } from "./PaymentMode/helper";
import { TbListDetails } from "react-icons/tb";
import { useToasts } from "react-toast-notifications";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { MdHistory, MdPayment } from "react-icons/md";
import PayNowDetails from "./Payments/payNow";
import { fetchAsyncGetPaymentDetail } from "redux/paymentSlice";
import useFormOptions from "hooks/FormOptions/useFormOptions";
import useOrganizationData from "hooks/organizaton/useOrganization";
import useAccountUser from "hooks/organizaton/useAccountUser";
import AmountInputField from "./component/amountField";
import DatePickerField from "./component/datePickerField";
import DrawerButton from "./component/buttons/drawerButton";

const PaymentInfoComponent = ({ keepPayeeEnabled,getData, autoCount, editData,paymentData,spentAmountError ,merchantValue,moduleInfo, deleteMultipleListItem,expenseType, role}) => {
  const [paymentDetail, setPaymentDetail] = useState("");
  const [payeeValue, setPayeeValue] = useState("");
  const [bankValue, setBankValue] = useState("");
  const [paymentAmount,setPaymentAmount] = useState("")
  const { addToast } = useToasts();
  const [openPayNow, setOpenPayNow] = useState(false)  
  const [addTogglePaymentIdx, setAddTogglePaymentIdx] = useState(true);
  const dispatch = useDispatch();
  const {organizationData} = useOrganizationData();
  const accountUser = useAccountUser();
  const {
    formOptionsList,
    payeeOption,
    bankOption,
    createNewFormOption,
    deleteFromOption,
    editFormOption,
  } = useFormOptions(expenseType);


  const fetchPaymentDetails = (pmId)=>{
    dispatch(fetchAsyncGetPaymentDetail({expenseId:editData?._id,paymentId:pmId})).then((res)=>{
      if(res?.payload){
        const payment = res?.payload?.payment;  
        if(payment && payment?._id)
          setPaymentDetail(payment)
          const pmt = payment?.amt 
          const ref = payment?.utr
          const payDate =  new Date(payment?.crAt);
          getData({
            amt: pmt ,
            refNo: ref,
            pmtDt:  payDate,
            isAuto:true
          })
      }
     
      }).catch((err)=>{
        addToast(`${err?.message}`, { appearance: "error" });
      })
  }

  useEffect(()=>{
    if(accountUser?.isA && !["directTax", "tds"].includes(expenseType)){
      if(accountUser?.isA && !paymentData?._id){
        getData({isAuto:true})
      }
      else{
        getData({isAuto:false})
      }
    }
  },[accountUser])

  const preAmount = useMemo(()=>{
    const data = editData?.pyInfo?.list[autoCount]
    const amount = data?.amt ? data?.amt : ""
    if(data && amount){
      return amount
    }
  },[editData?.pyInfo?.list,autoCount])

  const paymentId = useMemo(()=>{
    const pono = editData?.poNo;
    const index = autoCount + 1
    const id = createAmountID(pono,index)
    if(!["directTax", "tds"].includes(expenseType)){
      fetchPaymentDetails(id)
    }
    return id;
  },[editData?.poNo])

  useEffect(() => {
    if (paymentData && paymentData?.amt) {
      setPaymentAmount(paymentData?.amt)
      const payeeData = getOptionDataOnEdit(
        formOptionsList,
        paymentData?.pyId?._id || paymentData?.pyId,         
        "payee",
      );

      if (payeeData && payeeData?._id) {
        setPayeeValue({
          label: payeeData.lab,
          value: payeeData.val,
          id: payeeData?._id
        });
      }
      else if(!paymentData?.pyId){
        const orgName = organizationData?.name || ""
        const defaultPay = formOptionsList.find(option => 
          (option.val.toLowerCase().includes(orgName.toLowerCase()) || 
          option.expTyp === moduleInfo?.name) && 
          option.typ === 'payee'
        );
        
        if(defaultPay && defaultPay?._id){
          getData({pyId:defaultPay?._id})
          setPayeeValue({
            label: defaultPay.lab,
            value: defaultPay.val,
            id: defaultPay?._id
          });
        }
      }
      
      const bakData = getOptionDataOnEdit(
          formOptionsList,
          paymentData?.bnkId?._id || paymentData?.bnkId,         
          "bank",
      );
      if (bakData && bakData?._id) {
        setBankValue({
          label: bakData.lab,
          value: bakData.val,
          id: bakData?._id
        });
      }
      else if(!paymentData?.bnkId){
        const defaultBank = formOptionsList.find(option => 
          option.val.toLowerCase().includes("icici") && option.typ === 'bank'
        );
        
        if(defaultBank && defaultBank?._id){
          getData({bnkId:defaultBank?._id})
          setBankValue({
            label: defaultBank.lab,
            value: defaultBank.val,
            id: defaultBank?._id
          });
        }
      }
    }
  }, [paymentData,formOptionsList,organizationData]);

  
  const [openPdf, setOpenPdf] = useState(false)

  return (
    <div
      className={`payment-listing_box ${addTogglePaymentIdx ? "show" : "hide"}`}
    >
      <div className="payment-list_array">
        <Box display="flex" justifyContent="space-evenly">
          <span className="payment-details">{paymentId}</span>
          <span className="amountSpan" style={{ marginLeft: "3rem" }}>
            {paymentAmount ? currencyFormate(Number(paymentAmount)) : 0}
          </span>
          {accountUser?.isA && !["directTax", "tds"].includes(expenseType) && (
            <div className="d-flex ">
              <Form.Label className="mx-2">Manual</Form.Label>
              <Form.Check
                className="mt-0"
                type="switch"
                id="custom-switch"
                disabled={paymentDetail?._id}
                onChange={() => {
                  getData({ isAuto: !paymentData?.isAuto });
                }}
                checked={paymentData?.isAuto || paymentDetail?._id}
              />
              <Form.Label className="mx-1">Automated</Form.Label>
            </div>
          )}
        </Box>
        <div className="d-flex payment-pdf-icon"></div>

        <div className="d-flex mx-2">
          {!["directTax", "tds"].includes(expenseType) && (
            <>
              {!paymentDetail?._id
                ? accountUser?.isA &&
                  paymentData?.isAuto && (
                    <Button
                      className="btn payment-btn pay-now"
                      onClick={() => {
                        ConfirmationDialog({
                          title: "Ready to Proceed with Payment?",
                          text: `Confirm payment of ₹ ${formatAmountIndianRupees(
                            paymentAmount
                          )} now to complete your transaction.`,
                          icon: "warning",
                          confirmButtonText: "Confirm",
                          cancelButtonText: "Cancel",
                          onConfirm: () => {
                            setOpenPayNow(!openPayNow);
                          },
                        });
                      }}
                    >
                      <MdPayment /> <span className="mx-2">Pay Now</span>
                    </Button>
                  )
                : (role === "Admin" || accountUser?.isA) && (
                    <Button
                      className="btn payment-btn paid"
                      onClick={() => {
                        setOpenPayNow(!openPayNow);
                      }}
                    >
                      <MdHistory /> <span className="mx-2">History</span>
                    </Button>
                  )}
            </>
          )}

          <div className="d-flex payment-pdf-icon">
            {editData?.pyInfo?.list[autoCount] ? (
              <Tooltip
                label="Payment Advice"
                placement="bottom"
                hasArrow
                className="common-tooltip"
              >
                <div
                  onClick={() => {
                    setOpenPdf(!openPdf);
                  }}
                  className="ledger-icon"
                  style={{ cursor: "pointer" }}
                >
                  <TbListDetails />
                </div>
              </Tooltip>
            ) : null}
          </div>
          {["Admin", "Manager", "Accountant"].includes(role) &&
          preAmount !== 0 ? (
            <div
              className={`d-flex`}
              style={{ marginRight: "1rem" }}
              onClick={() => {
                !paymentDetail?._id && deleteMultipleListItem();
              }}
            >
              <Tooltip
                label={`${paymentDetail?._id ? "Not-Allowed" : "Delete"}`}
                placement="bottom"
                hasArrow
                className="common-tooltip"
              >
                <span className="mt">
                  <FaTrash
                    style={{
                      fontSize: "16px",
                      color: "red",
                      // marginTop: "10px",
                      cursor: "pointer",
                    }}
                    className={`${paymentDetail?._id ? "disabled-btn" : ""}`}
                  />
                </span>
              </Tooltip>
            </div>
          ) : (
            preAmount === 0 && (
              <div className="d-flex" onClick={() => deleteMultipleListItem()}>
                <span className="mt">
                  <FaTrash
                    style={{
                      fontSize: "16px",
                      color: "red",
                      // marginTop: "10px",
                      cursor: "pointer",
                    }}
                  />
                </span>
              </div>
            )
          )}
          <DrawerButton
            isOpen={addTogglePaymentIdx}
            handleClick={() => {
              setAddTogglePaymentIdx(!addTogglePaymentIdx);
            }}
          />
        </div>
      </div>

      <div
        className={`payment-inner_box ${
          addTogglePaymentIdx ? "show-content" : "hide-content"
        }`}
      >
        <Row className="">
          <Col>
            <Box display="flex" className="input-box">
              <Form.Label>
                Spent Amount <span className="span-star">*</span>
              </Form.Label>
              <Box>
                <AmountInputField
                  name="totalTax"
                  value={paymentAmount}
                  isDisabled={paymentDetail?._id}
                  handleChange={(value) => {
                    getData({ amt: value });
                    setPaymentAmount(value);
                  }}
                />
              </Box>
            </Box>
            <p className="form_error">
              {" "}
              {spentAmountError[`spent.${autoCount}.amount`]}
            </p>
          </Col>
          <Col></Col>
        </Row>
        {paymentData?.isAuto && paymentDetail?._id && (
          <>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Payee <span className="span-star">*</span>
                  </Form.Label>

                  <CustomSelect
                    options={payeeOption}
                    placeHolder={<div>Type or select...</div>}
                    onChange={(newValue) => {
                      setPayeeValue(newValue);
                      getData({ pyId: newValue?.id });
                    }}
                    isSearchable
                    onCreateOption={(e) => {
                      createNewFormOption(createOption(e), "payee");
                    }}
                    onDeleteOption={(option) => {
                      deleteFromOption(option, "payee");
                    }}
                    onEditOption={(option, newValue) => {
                      editFormOption(option, newValue, "payee");
                    }}
                    defaultValue={payeeValue}
                    role={role}
                    isDisabled={keepPayeeEnabled ? false : paymentDetail?._id}
                  />
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.payeeId`]}
                </p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Bank <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <CustomSelect
                      options={bankOption}
                      placeHolder={<div>Type or select...</div>}
                      onChange={(newValue) => {
                        setBankValue(newValue);
                        getData({ bnkId: newValue?.id });
                      }}
                      isSearchable
                      onCreateOption={(e) => {
                        createNewFormOption(createOption(e), "bank");
                      }}
                      onDeleteOption={(option) => {
                        deleteFromOption(option, "bank");
                      }}
                      onEditOption={(option, newValue) => {
                        editFormOption(option, newValue, "bank");
                      }}
                      defaultValue={bankValue}
                      role={role}
                      isDisabled={paymentDetail?._id}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.bankId`]}
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Reference Number <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <Form.Control
                      type="text"
                      name="referenceNo"
                      disabled={paymentDetail?._id}
                      placeholder="Reference Number"
                      onChange={(e) => {
                        getData({ refNo: e.target.value });
                      }}
                      value={paymentData?.refNo}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.refNo`]}
                </p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Date <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <DatePickerField
                      name="paymentdate"
                      isDisabled={paymentDetail?._id}
                      value={
                        paymentData?.pmtDt
                          ? new Date(paymentData.pmtDt)
                          : new Date()
                      }
                      formate="dd-MMM-yyyy"
                      handleChange={(date) => getData({ pmtDt: date })}
                      isMonthDropdown={true}
                      isYearDropdown={true}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.paymentDate`]}
                </p>
              </Col>
            </Row>
          </>
        )}
        {!paymentData?.isAuto && (
          <>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Payee <span className="span-star">*</span>
                  </Form.Label>

                  <CustomSelect
                    options={payeeOption}
                    placeHolder={<div>Type or select...</div>}
                    onChange={(newValue) => {
                      setPayeeValue(newValue);
                      getData({ pyId: newValue?.id });
                    }}
                    isSearchable
                    onCreateOption={(e) => {
                      createNewFormOption(createOption(e), "payee");
                    }}
                    onDeleteOption={(option) => {
                      deleteFromOption(option, "payee");
                    }}
                    onEditOption={(option, newValue) => {
                      editFormOption(option, newValue, "payee");
                    }}
                    defaultValue={payeeValue}
                    role={role}
                    isDisabled={paymentDetail?._id}
                  />
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.payeeId`]}
                </p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Bank <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <CustomSelect
                      options={bankOption}
                      placeHolder={<div>Type or select...</div>}
                      onChange={(newValue) => {
                        setBankValue(newValue);
                        getData({ bnkId: newValue?.id });
                      }}
                      isSearchable
                      onCreateOption={(e) => {
                        createNewFormOption(createOption(e), "bank");
                      }}
                      onDeleteOption={(option) => {
                        deleteFromOption(option, "bank");
                      }}
                      onEditOption={(option, newValue) => {
                        editFormOption(option, newValue, "bank");
                      }}
                      defaultValue={bankValue}
                      role={role}
                      isDisabled={paymentDetail?._id}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.bankId`]}
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Reference Number <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <Form.Control
                      type="text"
                      name="referenceNo"
                      disabled={paymentDetail?._id}
                      placeholder="Reference Number"
                      onChange={(e) => {
                        getData({ refNo: e.target.value });
                      }}
                      value={paymentData?.refNo}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.refNo`]}
                </p>
              </Col>
              <Col>
                <Box display="flex" className="input-box">
                  <Form.Label>
                    Date <span className="span-star">*</span>
                  </Form.Label>
                  <Box>
                    <DatePickerField
                      name="paymentdate"
                      isDisabled={paymentDetail?._id}
                      value={
                        paymentData?.pmtDt
                          ? new Date(paymentData.pmtDt)
                          : new Date()
                      }
                      formate="dd-MMM-yyyy"
                      handleChange={(date) => getData({ pmtDt: date })}
                      isMonthDropdown={true}
                      isYearDropdown={true}
                    />
                  </Box>
                </Box>
                <p className="form_error">
                  {" "}
                  {spentAmountError[`spent.${autoCount}.paymentDate`]}
                </p>
              </Col>
            </Row>
          </>
        )}
      </div>
      {openPdf && (
        <div className="payment-mode-pdf">
          <PaymentModePdf
            isOpen={openPdf}
            expenseData={editData}
            paymentData={{
              paymentId: paymentId,
              billNumber: paymentData?.blNo,
              paymentAmount: paymentAmount,
              payeeValue: payeeValue,
              refNo: paymentData?.refNo,
              bankValue: bankValue,
              selectedDate: paymentData?.pmtDt,
            }}
            autoCount={autoCount}
            onClose={() => setOpenPdf(!openPdf)}
            expenseType={expenseType}
          />
        </div>
      )}
      {openPayNow && (
        <PayNowDetails
          isOpen={openPayNow}
          closeModal={() => {
            setOpenPayNow(false);
            fetchPaymentDetails(paymentId);
          }}
          requestedAmount={paymentAmount}
          expenseId={editData?._id || ""}
          vendorId={merchantValue?.value}
          poNo={editData?.poNo}
          orderDate={editData?.oDt}
          moduleId={moduleInfo?._id}
          expenseType={moduleInfo?.name}
          paymentId={paymentId}
          accountUser={accountUser}
          autoCount={autoCount}
        />
      )}
    </div>
  );
};

export default PaymentInfoComponent;
